export default () => ({
  isPotLoading: true,
  isCreatingTransferPayment: false,
  pot: null,
  potRefunds: [],
  otherAppPotRefunds: [],
  transferPayments: [],
  previousTransferPaymentId: null,
})
